<template>
    <div>
        <!-- decrypt file -->
        <section class="accordions">
            <article class="accordion"
                        :class="{'is-active': decryptDialogVisible}">
                <div class="accordion-header toggle is-size-5"
                        @click="decryptDialogVisible = !decryptDialogVisible">
                    <a>Decrypt file ⯆</a>
                </div>
                <div class="accordion-body">
                    <div class="accordion-content has-background-dark has-text-white">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Password</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input v-model="password" class="input oc-input" type="text" />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Salt</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input v-model="salt" class="input oc-input" type="text" />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <uploader :upload-func="decrypt" />
                    </div>
                </div>
            </article>
        </section>

        <!-- reports list -->
        <table class="table">
            <tr>
                <th>#</th>
                <th>Started at</th>
                <th>Sent at</th>
                <th>Pass/salt</th>
                <th>File name</th>
                <th></th>
            </tr>
            <tr v-for="report in reports" :key="report.id">
                <td>{{report.number}}</td>
                <td>{{report.startedAt | datetime(true)}}</td>
                <td>{{report.sentAt | datetime(true)}}</td>
                <td>{{report.password}}/{{report.salt}}</td>
                <td>{{report.fileName}}</td>
                <td>
                    <a @click="download(report)" class="button is-small">download</a>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import curacaoSerivce from '../../../../services/curacao.service';
import utils from '../../../../utils';

import Uploader from '../../../common/uploader.vue';

export default {
    name: 'client-curacao',
    components: { Uploader },
    data() {
        return {
            reports: [],
            decryptDialogVisible: false,
            password: '',
            salt: ''
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    async mounted() {
        await this.loadReports();
    },
    methods: {
        async loadReports() {
            this.reports = await curacaoSerivce.getClientBalanceReports(this.clientId);
        },
        async download(report) {
            let fullReport = await curacaoSerivce.getBalanceReport(report.id);
            let fileName = `${report.clientId}_${report.startedAt}.csv`;
            utils.saveText(fullReport.reportContent, fileName);
        },
        async decrypt(formData) {
            let decrypted = await curacaoSerivce.decrypt(formData, this.password, this.salt);
            let fileName = 'decrypted.csv';
            utils.saveText(decrypted.decrypted, fileName);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/curacao/balance-reports.vue